module.exports = __webpack_public_path__ + "img/制御工学5_7.c7ceab85.png";